(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bae-native-review-form"] && !Shopify.designMode) return;
  try {
    (function(){
function bind(){
document.querySelectorAll('form.bae-reviews__form').forEach(function(form){
if(form.dataset.baeBound)return;
var body=form.querySelector('[name="comment[body]"]');
var text=form.querySelector('[name="bae_review_text"]');
if(!body||!text)return;
form.dataset.baeBound='true';
var restored=text.value.match(/^\[BAE-RATING:([1-5])\]\s*/);
if(restored){form.querySelector('[name="bae_review_rating"][value="'+restored[1]+'"]').checked=true;text.value=text.value.slice(restored[0].length);}
function sync(){var rating=form.querySelector('[name="bae_review_rating"]:checked');body.value=rating?'[BAE-RATING:'+rating.value+']\n'+text.value.trim():'';}
form.addEventListener('input',sync);form.addEventListener('change',sync);form.addEventListener('submit',sync);
sync();form.querySelector('button[type="submit"]').disabled=false;
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();
document.addEventListener('shopify:section:load',bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bae-ring-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.baeRingGuideReady) return;
    window.baeRingGuideReady = true;

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var root = event.target.closest('[data-bae-ring-guide]');
      if (!root) return;
      var dialog = root.querySelector('.bae-ring-guide__dialog');
      var target = event.target;

      if (target.closest('[data-bae-open]')) {
        if (!dialog.open) dialog.showModal();
        return;
      }
      if (target.closest('[data-bae-close]') || target.closest('[data-bae-back]') || target === dialog) {
        dialog.close();
        if (target.closest('[data-bae-back]')) {
          var picker = root.closest('.product-info');
          picker = picker && picker.querySelector('variant-picker');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      var tab = target.closest('[data-bae-tab]');
      if (tab) {
        var selectedTab = tab.dataset.baeTab;
        root.querySelectorAll('[data-bae-tab]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === tab)); });
        root.querySelectorAll('[data-bae-panel]').forEach(function (panel) { panel.hidden = panel.dataset.baePanel !== selectedTab; });
        return;
      }

      var unitButton = target.closest('[data-bae-unit]');
      if (unitButton) {
        var unit = unitButton.dataset.baeUnit;
        root.querySelectorAll('[data-bae-unit]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === unitButton)); });
        root.querySelectorAll('[data-bae-value]').forEach(function (cell) {
          var mm = Number(cell.dataset.baeValue);
          cell.textContent = (unit === 'cm' ? mm / 10 : mm / 25.4).toFixed(2);
        });
        root.querySelector('[data-bae-diameter-header]').textContent = dialog.dataset.baeDiameterName + ' (' + unit + ')';
        root.querySelector('[data-bae-circumference-header]').textContent = dialog.dataset.baeCircumferenceName + ' (' + unit + ')';
        return;
      }

      if (target.closest('[data-bae-calculate]')) {
        var field = root.querySelector('[data-bae-measurement]');
        var result = root.querySelector('[data-bae-result]');
        var value = Number(field.value);
        result.hidden = false;
        if (!field.value || !Number.isFinite(value) || value <= 0) {
          result.textContent = dialog.dataset.baeRequired;
          field.focus();
          return;
        }
        var unitFactor = root.querySelector('[data-bae-input-unit]').value === 'cm' ? 10 : 25.4;
        var mm = value * unitFactor;
        var method = root.querySelector('.bae-ring-guide__methods input:checked').value;
        var rows = Array.from(root.querySelectorAll('[data-bae-size]'));
        var first = Number(rows[0].dataset[method === 'diameter' ? 'baeDiameter' : 'baeCircumference']);
        var last = Number(rows[rows.length - 1].dataset[method === 'diameter' ? 'baeDiameter' : 'baeCircumference']);
        if (mm < first - .5 || mm > last + .5) {
          result.textContent = dialog.dataset.baeOutside;
          return;
        }
        var matchingRow = rows.find(function (row) {
          return mm <= Number(row.dataset[method === 'diameter' ? 'baeDiameter' : 'baeCircumference']) + 0.05;
        }) || rows[rows.length - 1];
        result.textContent = dialog.dataset.baeRecommend + ' US ' + matchingRow.dataset.baeSize + '. ' + dialog.dataset.baeEstimate;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bae-ugc-slider"] && !Shopify.designMode) return;
  try {
    if (!window.baeUgcBound) {
    window.baeUgcBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bae-direction]');
      if (!button) return;
      const gallery = button.closest('.bae-ugc');
      const track = gallery && gallery.querySelector('.bae-ugc__track');
      const slide = track && track.querySelector('.bae-ugc__slide');
      if (!track || !slide) return;
      const offset = slide.getBoundingClientRect().width + 9;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: Number(button.dataset.baeDirection) * offset, behavior: reduced ? 'instant' : 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
